/**
 * TableFilter Component
 * Renders a labeled input field for filtering table data.
 * @param {string} label - The label for the input field.
 * @param {string} inputType - The type of the input field (e.g., text, date).
 * @param {string} name - The name attribute for the input field.
 * @param {string} value - The current value of the input field.
 * @param {function} onChange - The function to call when the input value changes.
 **/

import { useTranslation } from "react-i18next";

export const TableFilter = ({
  label = null,
  inputType,
  name,
  value,
  onChange,
}) => {
  const { t } = useTranslation();
  return (
    <label>
      {label && t(`searchFilters.${label}`)}{" "}
      <input
        type={inputType}
        value={value}
        className={inputType === "checkbox" ? "checkbox-input-sm" : "text-input-sm"}
        name={name}
        onChange={onChange}
      />
    </label>
  );
};
